var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column ga-2 min-w-0",
      class: { "align-center text-center": _setup.isMobile },
    },
    [
      _c(
        "div",
        {
          staticClass: "min-w-0",
          class: _setup.isMobile
            ? "text-subtitle-1 font-weight-medium"
            : "text-h5 font-weight-medium text-no-wrap",
        },
        [
          _c(
            "a",
            {
              staticClass: "primary--text text-decoration-none",
              class: { "text-wrap": !_setup.isMobile },
              attrs: { href: _vm.doctorPageUrl },
            },
            [_vm._v(_vm._s(_setup.doctorName))]
          ),
          _vm._v(" "),
          !_setup.isMobile
            ? _c(_setup.DoctorCardActions, {
                staticClass: "ml-1",
                attrs: {
                  "doctor-id": _vm.doctor.id,
                  "doctor-page-url": _vm.doctorPageUrl,
                  size: 24,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _setup.specialityText
        ? _c(
            "div",
            {
              staticClass: "text-secondary--text",
              class: _setup.isMobile ? "text-body-2" : "text-body-1",
            },
            [_vm._v("\n    " + _vm._s(_setup.specialityText) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.doctor.is_award_or_grand_prix_winner
        ? _c(_setup.AwardWinner, {
            attrs: {
              type: "doctor",
              "redirect-url": `${_vm.doctorPageUrl}#medals`,
              "current-award-year": _setup.currentAwardYear,
              "is-award-or-grand-prix-winner": Boolean(
                _vm.doctor.is_award_or_grand_prix_winner
              ),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }